import { Link } from "react-router-dom";

export default function ObrasHelp() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 md:px-8">
      <div className="mx-auto max-w-5xl space-y-6">
        <header className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
          <div className="mb-4 flex justify-end">
            <Link
              to="/admcuru/obrasadm"
              className="inline-flex items-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
            >
              Volver
            </Link>
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
            📘 Página de Ayuda – Administración del sitio de Diego Curutchet
          </h1>
          <p className="mt-3 text-sm text-slate-600 md:text-base">
            Guía rápida para gestionar obras, imágenes y secciones del panel.
          </p>
        </header>

        {/* <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
          <h2 className="text-xl font-semibold text-slate-900">🔐 Acceso a la Administración</h2>
          <p className="mt-3 text-slate-700">Para ingresar al panel administrativo:</p>
          <ol className="mt-3 list-decimal space-y-2 pl-5 text-slate-700">
            <li>
              Entrá a la URL: <strong>http://diegocurutchet.com/admcuru</strong>
            </li>
            <li>
              Iniciá sesión con:
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li>
                  👤 <strong>Usuario:</strong> diego
                </li>
                <li>
                  🔑 <strong>Clave:</strong> bartolito
                </li>
              </ul>
            </li>
          </ol>
          <p className="mt-4 text-slate-700">Una vez dentro, verás un menú de opciones a la izquierda.</p>
        </section> */}

        <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
          <h2 className="text-xl font-semibold text-slate-900">📂 Menú de Opciones</h2>
          <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">👥 Clientes</h3>
              <p className="mt-1 text-sm text-slate-700">Lista de clientes registrados o que iniciaron sesión.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">🖼️ Obras</h3>
              <p className="mt-1 text-sm text-slate-700">Obras cargadas para la venta.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">🛒 Pedidos</h3>
              <p className="mt-1 text-sm text-slate-700">Pedidos realizados por los clientes.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">💲 Cotizaciones</h3>
              <p className="mt-1 text-sm text-slate-700">Solicitudes de cotización enviadas por los clientes.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">✉️ Contactos</h3>
              <p className="mt-1 text-sm text-slate-700">Mensajes recibidos desde la página.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="font-semibold text-slate-900">📋 Tablas</h3>
              <p className="mt-1 text-sm text-slate-700">Tablas internas del sistema.</p>
            </article>
            <article className="rounded-xl border border-slate-200 bg-slate-50 p-4 sm:col-span-2 lg:col-span-3">
              <h3 className="font-semibold text-slate-900">🛡️ Administradores</h3>
              <p className="mt-1 text-sm text-slate-700">Usuarios autorizados para administrar la aplicación.</p>
            </article>
          </div>
        </section>

        <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
          <h2 className="text-xl font-semibold text-slate-900">🆕 Cómo Crear una Nueva Obra</h2>
          <ol className="mt-3 list-decimal space-y-2 pl-5 text-slate-700">
            <li className="text-left">
              Ir a <strong>Obras</strong>.
            </li>
            <li className="text-left">
              Hacer clic en <strong>“+ Nuevo”</strong> ➕.
            </li>
            <li className="text-left">
              Completar los datos solicitados:
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li className="text-left">
                  🏷️ <strong>Clasificaciones:</strong> Mientras más agregues, más fácil será que los clientes encuentren la obra.
                </li>
                <li className="text-left">
                  💵 <strong>Precio:</strong> En dólares.
                </li>
                <li className="text-left">
                  🔄 <strong>Estado inicial:</strong> Activo.
                </li>
              </ul>
            </li>
          </ol>

          <h3 className="mt-6 text-lg font-semibold text-slate-900">📌 Otros estados</h3>
          <ul className="mt-2 list-disc space-y-1 pl-5 text-slate-700">
            <li className="text-left">
              ❄️ <strong>Congelado:</strong> La obra está cargada pero no disponible.
            </li>
            <li className="text-left">
              📦 <strong>Entregado:</strong> Obra vendida y despachada.
            </li>
            <li className="text-left">
              🧾 <strong>Pedido:</strong> Un cliente la está queriendo comprar (no aparecerá en el listado de venta).
            </li>
          </ul>
        </section>

        <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
          <h2 className="text-xl font-semibold text-slate-900">🖼️ Cómo Subir Imágenes a una Obra</h2>
          <ol className="mt-3 list-decimal space-y-2 pl-5 text-slate-700">
            <li className="text-left">
              Entrar a la obra y luego a clickear en <strong>Imágenes</strong>.
            </li>
            <li className="text-left">
              Hacer clic en <strong>“+ Nuevo”</strong>.
            </li>
            <li className="text-left">
              Completar los datos:
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li className="text-left">
                  📝 <strong>Título corto:</strong> Breve descripción.
                </li>
                <li className="text-left">
                  ⚙️ <strong>Estado:</strong> Activo.
                </li>
                <li className="text-left">
                  📁 <strong>Seleccionar Archivo:</strong> Elegir la imagen deseada.
                </li>
              </ul>
            </li>
            <li className="text-left">Guardar la imagen.</li>
          </ol>

          <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4 text-slate-700">
            <p>
              💡 <em>La primera imagen será la que verá el cliente en el listado de obras.</em>
            </p>
            <p className="mt-1">Podés agregar más imágenes si querés mostrar más detalles.</p>
          </div>
        </section>

        <section className="rounded-2xl border border-emerald-200 bg-emerald-50 p-6 md:p-8">
          <h2 className="text-xl font-semibold text-emerald-900">✅ ¡Obra cargada!</h2>
          <p className="mt-2 text-emerald-800">
            Una vez creados los datos y agregadas las imágenes, la obra ya estará disponible según su estado.
          </p>
        </section>
      </div>
    </main>
  );
}